<template>
  <div class="date_picker" @click.stop.prevent>
    <div class="date_picker_content">
      <div class="date_picker_timezone--wrap">
        <div class="date_picker_timezone">
          <p class="value">({{timezone}}) {{timezoneName}}</p>
        </div>
<!--        <div v-else>-->
<!--          <p class="not-change-timezone">{{ $t('common.calendar.notChangeTimezone') }}</p>-->
<!--        </div>-->
      </div>
      <div class="calendar clearfix">
        <month-calendar v-if="computedMonthStr"
                        :monthStr="computedMonthStr"
                        :targetDate="computedTargetDate"
                        :minDate="minDate"
                        :maxDate="maxDate"
                        :disabled="disabled"
                        :timezone="timezone"
                        :timezoneName="timezoneName"
                        @onMonthAdd="onMonthAdd"
                        @onDateClick="onDateClick"/>
      </div>
    </div>
    <div v-if="isFromNow !== undefined" class="date_picker_option">
      <p>
        <ui-checkbox :value="fromNow"
          @input="onIsFromNowChange($event)">{{ $t('common.instantlyStart') }}</ui-checkbox>
      </p>
    </div>
    <div v-if="isEndless !== undefined" class="date_picker_option">
      <p>
        <ui-checkbox :value="endless"
          @input="onIsEndlessChange($event)">{{ $t('common.nonStop') }}</ui-checkbox>
      </p>
    </div>
    <slot name="calendarOptions"></slot>
    <button type="button" class="btn-close"
      @click.stop="$emit('onCloseClick')">
      <i class="icon icon--close-btn"></i>
    </button>
  </div>
</template>

<script>
import { parse, format, addMonths, addDays } from 'date-fns'
import MonthCalendar from './MonthCalendar'
import UiCheckbox from '@/components/ui/UiCheckbox'
import { getOffset, utcToLocalTimezone } from '@/libs/utils'

export default {
  name: 'DatePicker',
  components: {
    MonthCalendar,
    UiCheckbox
  },
  props: {
    timezoneName: {
      type: String,
      required: false,
      default: 'Asia/Seoul'
    },
    value: {
      type: String,
      required: false
    },
    minDate: {
      type: Date,
      required: false
    },
    maxDate: {
      type: Date,
      required: false
    },
    isFromNow: {
      required: false
    },
    isEndless: {
      required: false
    }
  },
  data () {
    return {
      monthStr: null,
      targetDate: null,
      fromNow: this.isFromNow,
      endless: this.isEndless,
      timezone: getOffset(this.timezoneName)
    }
  },
  computed: {
    computedTargetDate () {
      if (this.fromNow) {
        return utcToLocalTimezone(new Date(), this.timezoneName)
      } else if (this.endless) {
        return null
      } else {
        return this.targetDate
      }
    },
    computedMonthStr () {
      if (this.fromNow || this.endless) {
        return format(new Date(), 'YYYY-MM-DD')
      }
      return this.monthStr
    },
    disabled () {
      return this.fromNow || this.endless
    }
  },
  created () {
    let date

    if (this.value) {
      date = parse(this.value)
      this.targetDate = date
    } else {
      date = utcToLocalTimezone(new Date(), this.timezoneName)
    }

    this.monthStr = format(date, 'YYYY-MM')
    this.closeFn = () => {
      this.$emit('onCloseClick')
    }
    document.body.addEventListener('click', this.closeFn, false)
  },
  methods: {
    onMonthAdd (months) {
      let monthDate = parse(this.monthStr)
      monthDate = addMonths(monthDate, months)
      this.monthStr = format(monthDate, 'YYYY-MM-DD')
    },
    onDateClick (type, date) {
      this.$emit('input', format(date, 'YYYY-MM-DD'))
      this.$emit('onCloseClick')
    },
    onIsFromNowChange (value) {
      this.fromNow = value

      if (value) {
        this.$emit('input', null)
        this.$emit('onCloseClick')
      } else {
        this.targetDate = parse(this.minDate)
      }
    },
    onIsEndlessChange (value) {
      this.endless = value

      if (value) {
        this.$emit('input', null)
        this.$emit('onCloseClick')
      } else {
        this.targetDate = parse(addDays(this.minDate, 6))
      }
    }
  },
  destroyed () {
    document.body.removeEventListener('click', this.closeFn)
  }
}
</script>

<style lang="scss" scoped="scoped">
.date_picker {
  .not-change-timezone {
    color: #e92020;
    font-size: 12px;
    transform: translateY(5px);
  }
}
</style>
